import { render, staticRenderFns } from "./CustomizationTemplates.vue?vue&type=template&id=53210072&lang=pug"
import script from "./CustomizationTemplates.vue?vue&type=script&lang=js"
export * from "./CustomizationTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports